import i18next, { type i18n } from "i18next";
import { initReactI18next } from "react-i18next";
import uz from "./uz.json";

export const resources = { uz: { translation: uz } } as const;
export type TranslationKeys = typeof uz;

/** Uzbek Latin is the only UI language at launch; adding a language means adding a resource file here. */
export function initI18n(): i18n {
  if (!i18next.isInitialized) {
    void i18next.use(initReactI18next).init({
      resources,
      lng: "uz",
      fallbackLng: "uz",
      supportedLngs: ["uz"],
      interpolation: { escapeValue: false },
      returnNull: false,
    });
  }
  return i18next;
}

export { i18next };
